import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { BellIcon } from "../icons/BellIcon";
import * as Styled from "./ActivityEventIcon.styled";
export const ActivityEventIcon = forwardRef((props, ref) => {
    /* istanbul ignore next */
    const { icon, palette = "expressiveInformative", indicatorType = "icon", ...otherProps } = props;
    const displayIcon = icon || _jsx(BellIcon, { size: 16, "aria-hidden": "true" });
    return (_jsx(Styled.IconWrapper, { ref: ref, "data-testid": "ActivityEventIcon", palette: palette, indicatorType: indicatorType, ...otherProps, children: displayIcon }));
});
ActivityEventIcon.displayName = "ActivityEventIcon";
ActivityEventIcon.defaultProps = {
    indicatorType: "icon",
    palette: "expressiveInformative"
};
